package com.elan.edubridge.ui.staff

import com.elan.edubridge.shared.domain.model.AttendanceSummary

/** 통계 4타일(가이드 §3.4): 수업 / 등원 / 하원 / 미등원. C1 해소안의 의미 색을 그대로 쓴다. */
object StatTiles {
    fun render(summary: AttendanceSummary): String = """
        <section class="eb-stat-tiles" aria-label="오늘 현황">
            <div class="eb-stat-tile"><span class="eb-stat-tile__label">수업</span><strong class="eb-stat-tile__value">${summary.classCount}</strong></div>
            <div class="eb-stat-tile"><span class="eb-stat-tile__label">등원</span><strong class="eb-stat-tile__value eb-text-success">${summary.checkedInCount}</strong></div>
            <div class="eb-stat-tile"><span class="eb-stat-tile__label">하원</span><strong class="eb-stat-tile__value eb-text-info">${summary.checkedOutCount}</strong></div>
            <div class="eb-stat-tile"><span class="eb-stat-tile__label">미등원</span><strong class="eb-stat-tile__value eb-text-error">${summary.notArrivedCount}</strong></div>
        </section>
    """.trimIndent()
}
